import Validatable from '@/validator/Validatable';

export interface IEstimatedReachPerUnitAPI {
  estimated_reach_by_unit_id: Record<number, number>;
  estimated_audience_reach_by_unit_id: Record<number, number>;
  estimated_reach: number;
  estimated_audience_reach: number;
}

export interface IEstimatedReachTargetParams {
  unit_ids: number[];
  demographic_ids: number[];
  from_date?: string;
  to_date?: string;
  daypart?: string;
  ad_duration: number;
  screen_frequency_cap: number;
  apply_realtime_multiplier?: boolean;
  impression_goal: number;
}

export class ReachStatistics extends Validatable {
  constructor(
    public reachPerUnit: Record<number, number>,
    public audienceReachPerUnit: Record<number, number>,
    public reach: number,
    public audienceReach: number,
  ) {
    super();
  }

  static fromApi(apiData: IEstimatedReachPerUnitAPI): ReachStatistics {
    return new ReachStatistics(
      apiData.estimated_reach_by_unit_id,
      apiData.estimated_audience_reach_by_unit_id,
      apiData.estimated_reach,
      apiData.estimated_audience_reach,
    );
  }
}
